import React, {useEffect, useState} from 'react';
import {showError} from "../../../utils/NotificationUtils";
import {useIntegrationsContext} from "../../../api/integrations/IntegrationsContext";
import {useHistory, useParams} from "react-router";
import {makeStyles} from "@mui/styles";
import {InfoBanner} from "../../ui/InfoBanner";
import {Loader} from "../../ui/Loader";
import {GetIntegrationTriggerProps} from "../../../api/integrations/IntegrationsDTO";
import {IntegrationEventSteps} from "../IntegrationEventSteps";
import IconButton from "@mui/material/IconButton";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';

const useStyles = makeStyles(() => ({
    root: {
        padding: 40,
    },
    container: {
        maxWidth: 1100,
        margin: "0 auto"
    }
}));

export function IntegrationTriggerEditor() {
    const classes = useStyles();

    const [data, setData] = useState<GetIntegrationTriggerProps | null>(null);
    const [loading, setLoading] = useState(true);
    const {IntegrationsApi} = useIntegrationsContext();
    const params: any = useParams();
    const history = useHistory();

    useEffect(() => {
        IntegrationsApi.getIntegrationTriggerById({params: {id: params.triggerId}}).then(res => {
            setData(res.payload);
            setLoading(false)
        }).catch(err => {
            showError(err)
            setLoading(false)
        })
    }, [IntegrationsApi, params]);

    const handleDataChange = (name: string, value: any) => {
        //@ts-ignore
        setData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };
    return (
        <div className={classes.root}>
            {
                loading ? <Loader /> : (
                    data && (
                        <div className={classes.container}>
                            <div>
                                <h3>
                                    <IconButton sx={{mr: 1}} onClick={() => history.goBack()}>
                                        <ArrowBackIosNewIcon />
                                    </IconButton>
                                    {data?.name}{" "}Trigger
                                </h3>
                            </div>
                            <InfoBanner title="Connect Your API"
                                        description="Now, configure how to get data from your API endpoint, and optionally send data from input fields. Select your trigger type, fill in each field or customize the code, then test your trigger and define the data it returns."/>
                            <IntegrationEventSteps isTrigger={true} onChange={handleDataChange} data={data}/>
                        </div>
                    )
                )
            }
        </div>
    );
}

